// import { Button, Container } from "@mui/material";
// import { apiReq } from "@services/backend";
// import React, { useEffect, useState } from "react";
// import { RefetchIndicator } from "../components/_Misc";
// // import { UserSearch } from "../components/Search/UserSearch";
import { useDocumentTitle } from "@hooks/useDocumentTitle";

export const TestPage: React.FC = () => {
  useDocumentTitle("test");

  return (
    <>
      {/* <ReactPlayer
        // url={"https://drive.google.com/u/0/open?id=1lRC4YTrH0-F7OsR-5Af8kRIzeTM4LEX6"}
        // This only works if the file is <100M~
        // url={"https://docs.google.com/uc?export=download&id=1lRC4YTrH0-F7OsR-5Af8kRIzeTM4LEX6"}
        // url={`https://www.googleapis.com/drive/v3/files/1lRC4YTrH0-F7OsR-5Af8kRIzeTM4LEX6?alt=media&key=DRIVE_API_KEY`}
        url={"https://docs.google.com/uc?export=download&id=1Vt3zME_Y4KmZi6x4CpekHLmxv5P7QnIf"}
        controls={true}
        onStart={() => console.log("onStart")}
        onPause={() => console.log("onPause")}
        onEnded={() => console.log("onEnded")}
        onSeek={(s) => console.log("onSeek", s)}
        onProgress={(p) => {
          console.log("onProgress", p);
        }}
        onDuration={(dur) => console.log("onDuration", dur)}
      /> */}
    </>
  );
};

// export const TestPage: React.FC = () => {
//   useDocumentTitle("Test");
//   // return <Container maxWidth="md">{/* <UserSearch /> */}</Container>;

//   const [trigger, setTrigger] = useState(false);
//   const [remoteHtml, setHtml] = useState("");
//   useEffect(() => {
//     (async () => {
//       const r = await apiReq.get("/static");
//       setHtml(r.data);
//       console.log(r.data);
//     })();
//   }, [trigger]);

//   return (
//     <Container maxWidth="xs">
//       <Button onClick={() => setTrigger(!trigger)}></Button>
//       <div dangerouslySetInnerHTML={{ __html: remoteHtml }} />
//       {/* <BuyMeACoffee /> */}
//       {/* <BecomePatron /> */}
//       <RefetchIndicator visible={false} />
//     </Container>
//   );
// };
